module.exports = __webpack_public_path__ + "assets/fonts/din-medium.1bbe3460.otf";